module.exports = __webpack_public_path__ + "media/images/logo_grnsw-ceca92b0326986a8ba75b0e7c41e1902.png";